import api from "utils/api";

export const axiosBaseQuery =
  ({ baseUrl = "" } = {}) =>
  async ({ url, method = "GET", data, body, params, headers, responseType }) => {
    try {
      const result = await api.request({
        url: `${baseUrl}${url}`,
        method,
        data: data ?? body,
        params,
        headers,
        responseType,
      });

      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError || {};
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

